module.exports = __webpack_public_path__ + "static/media/vlad_samson.a4ebf7fa.jpg";